 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-de-json":"lang-de-json","lang-el-json":"lang-el-json","lang-es-json":"lang-es-json","lang-fr-json":"lang-fr-json","lang-nl-json":"lang-nl-json","lang-ru-json":"lang-ru-json"}[chunkId]||chunkId) + "." + {"chunk-014e4388":"785ba5f4","chunk-03b11755":"10d6b91a","chunk-05374bfe":"d3cbd67a","chunk-0f2be54a":"c5014f2f","chunk-13896bdd":"5a4d4b14","chunk-1c4224a2":"6529d9be","chunk-1d2e79a7":"9c58a098","chunk-1d4a9f46":"f05e1ede","chunk-24adce0c":"dff1a520","chunk-2c48e82f":"8a06fbe9","chunk-2d0bd926":"ab24e5ac","chunk-2d0f0d70":"4bebae06","chunk-2d22cf89":"70f9f63b","chunk-318702cd":"2323895b","chunk-3696aa38":"284c646d","chunk-36e47dbf":"328b92fa","chunk-3880c184":"11a1fb9e","chunk-39e581a7":"c66f65e2","chunk-3dd65bc4":"ca8134d6","chunk-487e572f":"37c711d5","chunk-4b429333":"810078d0","chunk-5894c688":"3c4eaac4","chunk-5d6f9d99":"8cf38f27","chunk-5ff23704":"e0e91b42","chunk-63126a7e":"5d6e8c58","chunk-26191151":"3c85ff20","chunk-5994b56d":"c2fc2842","chunk-66014104":"89877fe9","chunk-59b3f5b5":"0c744d5b","chunk-7884afad":"cd15a96b","chunk-f80dc512":"df83cedc","chunk-6bc8ae42":"270df3f2","chunk-a5868c62":"ffe5e9bd","chunk-792a1a0e":"a032ac87","chunk-65871236":"5d7c118c","chunk-6735901c":"767cc0f2","chunk-69818414":"270955c9","chunk-45ae2f3e":"caab7316","chunk-6beb78d8":"47b687fc","chunk-6cca4b96":"867c546d","chunk-73cbbd18":"2b56e2e0","chunk-7573800e":"f5c54983","chunk-797e5c5f":"17422bef","chunk-9348767a":"6f370c18","chunk-96664022":"79d90a4b","chunk-a122b05e":"4a35e2cc","chunk-ba1c8dec":"1cf33b16","chunk-bc154010":"b4817b8b","chunk-bcfd8096":"b5771c80","chunk-c2329624":"5e08baef","chunk-c98b3684":"fcffe79a","chunk-cb6c6780":"72a54991","chunk-d500c1b6":"05a380ba","chunk-e2b6f36c":"ade739d8","chunk-f2a43860":"f8767489","chunk-f774bdb6":"8fe5c272","lang-de-json":"caf3c3f9","lang-el-json":"e4fb27a8","lang-es-json":"5d992301","lang-fr-json":"a488afe2","lang-nl-json":"b31b3fab","lang-ru-json":"97b7a651"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03b11755":1,"chunk-05374bfe":1,"chunk-0f2be54a":1,"chunk-13896bdd":1,"chunk-1c4224a2":1,"chunk-1d2e79a7":1,"chunk-1d4a9f46":1,"chunk-2c48e82f":1,"chunk-318702cd":1,"chunk-3696aa38":1,"chunk-36e47dbf":1,"chunk-39e581a7":1,"chunk-3dd65bc4":1,"chunk-487e572f":1,"chunk-4b429333":1,"chunk-5894c688":1,"chunk-5d6f9d99":1,"chunk-5ff23704":1,"chunk-26191151":1,"chunk-66014104":1,"chunk-59b3f5b5":1,"chunk-7884afad":1,"chunk-f80dc512":1,"chunk-a5868c62":1,"chunk-792a1a0e":1,"chunk-65871236":1,"chunk-6735901c":1,"chunk-69818414":1,"chunk-45ae2f3e":1,"chunk-6beb78d8":1,"chunk-6cca4b96":1,"chunk-73cbbd18":1,"chunk-7573800e":1,"chunk-797e5c5f":1,"chunk-9348767a":1,"chunk-96664022":1,"chunk-a122b05e":1,"chunk-ba1c8dec":1,"chunk-bc154010":1,"chunk-bcfd8096":1,"chunk-c2329624":1,"chunk-c98b3684":1,"chunk-cb6c6780":1,"chunk-d500c1b6":1,"chunk-e2b6f36c":1,"chunk-f2a43860":1,"chunk-f774bdb6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-de-json":"lang-de-json","lang-el-json":"lang-el-json","lang-es-json":"lang-es-json","lang-fr-json":"lang-fr-json","lang-nl-json":"lang-nl-json","lang-ru-json":"lang-ru-json"}[chunkId]||chunkId) + "." + {"chunk-014e4388":"31d6cfe0","chunk-03b11755":"a14c17f1","chunk-05374bfe":"7899d855","chunk-0f2be54a":"404013bf","chunk-13896bdd":"36ee188a","chunk-1c4224a2":"36ee188a","chunk-1d2e79a7":"ce72fc2b","chunk-1d4a9f46":"a87afaea","chunk-24adce0c":"31d6cfe0","chunk-2c48e82f":"05ae7970","chunk-2d0bd926":"31d6cfe0","chunk-2d0f0d70":"31d6cfe0","chunk-2d22cf89":"31d6cfe0","chunk-318702cd":"bc339788","chunk-3696aa38":"0cf3f6ca","chunk-36e47dbf":"5d5e220a","chunk-3880c184":"31d6cfe0","chunk-39e581a7":"d75668f0","chunk-3dd65bc4":"2ae9f700","chunk-487e572f":"2a31b700","chunk-4b429333":"b0c47d01","chunk-5894c688":"e0f9f45c","chunk-5d6f9d99":"3ea69a73","chunk-5ff23704":"9c4cd865","chunk-63126a7e":"31d6cfe0","chunk-26191151":"eda95300","chunk-5994b56d":"31d6cfe0","chunk-66014104":"9577da7a","chunk-59b3f5b5":"7ed769ea","chunk-7884afad":"1a193f98","chunk-f80dc512":"61745b04","chunk-6bc8ae42":"31d6cfe0","chunk-a5868c62":"966c172f","chunk-792a1a0e":"9e800950","chunk-65871236":"d14b5bce","chunk-6735901c":"cb2bf7da","chunk-69818414":"bdec56e3","chunk-45ae2f3e":"b64ab473","chunk-6beb78d8":"67f51761","chunk-6cca4b96":"979de51a","chunk-73cbbd18":"09f18abe","chunk-7573800e":"5aa99796","chunk-797e5c5f":"85c0e150","chunk-9348767a":"3dd8ca3f","chunk-96664022":"36ee188a","chunk-a122b05e":"671a20ff","chunk-ba1c8dec":"54609b4c","chunk-bc154010":"d5cd2e15","chunk-bcfd8096":"660b2f6e","chunk-c2329624":"25afe727","chunk-c98b3684":"8a517375","chunk-cb6c6780":"5f935e89","chunk-d500c1b6":"e15e59d5","chunk-e2b6f36c":"8d245486","chunk-f2a43860":"36ee188a","chunk-f774bdb6":"5c032fbf","lang-de-json":"31d6cfe0","lang-el-json":"31d6cfe0","lang-es-json":"31d6cfe0","lang-fr-json":"31d6cfe0","lang-nl-json":"31d6cfe0","lang-ru-json":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
